import { useRef } from "react";
import Checkbox, { IToggleButton } from "../gui/Button/Checkbox";
import useConfirm from "../gui/Dialogs/Confirm";
import { FMFile } from "../shared/FMFile";
import { useSnackbar } from "../gui/Snackbar/SnackbarProvider";
import Files from "./Files";

export default function useDeleteFiles(){
    const {confirm} = useConfirm()
    const {addSnackbar} = useSnackbar()

    const bRecursive = useRef<IToggleButton|null>(null)

    const onDelete = (files:FMFile[]) => async (dismiss:Function) => {
        dismiss()
        try {
            await Files.i.deleteFile(files, !!bRecursive.current?.checked)
        }catch(e){
            addSnackbar(e)
        }
    }
    const deleteFiles = (files:FMFile[]) => {
        const filename = files.map(file => file.name).join(", ")
        const hasDir = files.findIndex(f => FMFile.isDir(f))>=0
        confirm({
            msg:`Are you sure you wish to delete ${filename}?`,
            content:hasDir ? <Checkbox ref={bRecursive}>Delete recursively?</Checkbox> : <></>,
            onYes:onDelete(files),
            buttonYesProps:{size:"medium",className:"red"},
            buttonCancelProps:{size:"medium"}
        })
    }
    return {deleteFiles}
}